module.exports = __webpack_public_path__ + "img/hw.8c69acc8.svg";